import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import type { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { isEventsPage } from '@ms/yammer-web-support/dist/location';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePromptsByType = (promptTypes: DismissablePromptType[]) => void;
export const useLoadDismissablePromptsByType: UseLoadDismissablePromptsByType = (promptTypes) => {
  const dispatch = useDispatch();
  const isLiveEventPage = isEventsPage(window.location.pathname);

  // Re-derive the stable prompt types only when their serialized content actually changes, so the effect below
  // does not re-fire on every render when callers pass a new array instance with the same contents.
  const [signature, setSignature] = useState(() => JSON.stringify(promptTypes));
  const [stablePromptTypes, setStablePromptTypes] = useState(promptTypes);
  const nextSignature = JSON.stringify(promptTypes);
  if (signature !== nextSignature) {
    setSignature(nextSignature);
    setStablePromptTypes(promptTypes);
  }

  useEffect(() => {
    if (isLiveEventPage) {
      return;
    }

    dispatch(loadDismissablePrompts({ promptTypes: stablePromptTypes }));
  }, [dispatch, stablePromptTypes, isLiveEventPage]);
};
